import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const SnowflakeIntegration = React.lazy(() => import("./SnowflakeIntegration"));

interface SnowflakeIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function SnowflakeIntegrationLazy(props: SnowflakeIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <SnowflakeIntegration {...props} />
    </Suspense>
  );
}
